export default function authDataMethods(params) {
  // 原子权限
  const newAuthDataParams = {
    PREVIEW: params.PREVIEW,
    DOWNLOAD: params.DOWNLOAD,
    UPLOAD: params.UPLOAD,
  }
  return newAuthDataParams
}
